import React from "react";
import Title from "./Title";
import ContactDetails from "./ContactDetails";
import FormGetQuote from "./FormGetQuote";

export default function GetQuoteScreen() {
  return (
    <div className="creatyea-padding get-a-quote-section">
      <div className="row">
        <div className="col-lg-8">
          <Title />
          <FormGetQuote />
        </div>
        <ContactDetails />
      </div>
    </div>
  );
}
